//// delivery-info
class JapaneseHolidayChecker {
  constructor() {
    this.apiUrl = "https://holidays-jp.github.io/api/v1/date.json";
    this.holidayData = null;
  }

  fetchHolidayDataSync() {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", this.apiUrl, false);
    xhr.send();

    if (xhr.status === 200) {
      try {
        return JSON.parse(xhr.responseText);
      } catch (error) {
        console.error("JSONデータの解析に失敗しました。", error.message);
        return null;
      }
    } else {
      console.error(`APIからデータの取得に失敗しました (${xhr.status})`);
      return null;
    }
  }

  formatDate(year, month, day) {
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  isJapaneseHoliday(year, month, day) {
    const dateStr = this.formatDate(year, month, day);
    return this.holidayData && this.holidayData.hasOwnProperty(dateStr);
  }

  checkHolidayStatus(year, month, day) {
    if (!this.holidayData) {
      this.holidayData = this.fetchHolidayDataSync();
      if (!this.holidayData) {
        console.log("祝日データの取得に失敗したため、祝日の判定ができません。");
        return false;
      }
    }
    return this.isJapaneseHoliday(year, month, day);
  }
}

function checkShippingDate(){
  let weekday_items = document.querySelectorAll('.js-ship-weekday');
  const weekday_flag = weekday_items.length > 0;
  
  const youbiJp = ["日", "月", "火", "水", "木", "金", "土"];
  const currentDate = new Date();
  const tomorrowDate = new Date();
  tomorrowDate.setDate(currentDate.getDate() + 1);

  const dayOfWeek = currentDate.getDay();
  const isWeekday = dayOfWeek >= 1 && dayOfWeek <= 4;

  const currentHours = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();
  const currentSeconds = currentDate.getSeconds();

  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();
  const currentYoubi = youbiJp[currentDate.getDay()];

  const tomorrowYear = tomorrowDate.getFullYear();
  const tomorrowMonth = tomorrowDate.getMonth() + 1;
  const tomorrowDay = tomorrowDate.getDate();
  const tomorrowYoubi = youbiJp[tomorrowDate.getDay()];

  const current_date = document.getElementById('delivery-info_time');
  const shipping_date = document.getElementById('delivery-info_date');
  
  const formattedTime = "現在時刻 "+`${currentHours}:${String(currentMinutes).padStart(2, '0')}`;
/*
  const holidayChecker = new JapaneseHolidayChecker();
  let isHoliday_today = holidayChecker.checkHolidayStatus(currentYear, currentMonth, currentDay);
  let isHoliday_tomorrow = holidayChecker.checkHolidayStatus(tomorrowYear, tomorrowMonth, tomorrowDay);
*/
  if(!current_date){return;}
  current_date.textContent = formattedTime;

  if (currentDate.getHours() >= 0 && currentDate.getHours() < 13) {
    //【全日】0時から13時までの処理;
    shipping_date.innerHTML = "13時までの決済確認で<span class='delivery_date'>本日"+currentMonth+"/"+currentDay+"（"+currentYoubi+"）"+"出荷！</span>";
  }else{
    //【全日】13時から24時までの処理;
    shipping_date.innerHTML = "明日13時までの決済確認で、<span class='delivery_date'>明日"+tomorrowMonth+"/"+tomorrowDay+"（"+tomorrowYoubi+"）"+"出荷！</span>";
  }
  
  setTimeout(checkShippingDate, 60000);
}


if(document.getElementById('delivery-info')){
  checkShippingDate();
}
/////

(function($){

  //easing
  var pow=Math.pow,sqrt=Math.sqrt,sin=Math.sin,cos=Math.cos,PI=Math.PI,c1=1.70158,c2=1.525*c1,c3=c1+1,c4=2*PI/3,c5=2*PI/4.5;$.extend($.easing,{def:"easeOutQuart",easeInQuad:function(e){return e*e},easeOutQuad:function(e){return 1-(1-e)*(1-e)},easeOutQuart:function(e){return 1-pow(1-e,4)}});
  
  if($(".js-mv-slider-01").length){
    /*
    var swiper = new Swiper(".js-mv-slider-01", {
      allowTouchMove: true,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      speed: 2000,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
    });*/

    var swiper = new Swiper(".js-mv-slider-01", {
      loop: true,
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        1000: {
          speed: 1500,
          slidesPerView: 1.3,
          spaceBetween: 30
        }
      },
      on: {
        init: function () {
          $('.top-slide').addClass('__on');
        },
      }
    });
    
  }
    

  $('.js-accordion-sw').on('click',function(){
    $(this).closest('.js-accordion').toggleClass('__open').find('.js-accordion-content').slideToggle(100);
  });

  if($('#product-info-duplication').length){
    const product = $('.product').clone();
    $('#product-info-duplication').append(product);
  }

  //
  if($('.js-fade').length){
    inView.offset(200);
    inView('.js-fade').on('enter', el => {
      el.classList.add('__on');
    });
  }
  //
  if($('#to-cart-baloon-container').length){
    const show_point = $(window).height() * 1.5;
    $(window).on("scroll", function () {
      show_point < $(this).scrollTop() ? $('#to-cart-baloon-container, #coupon-baloon-switch').addClass('__on') : $('#to-cart-baloon-container, #coupon-baloon-switch').removeClass('__on');
    }).trigger('scroll');
    const variantSelector = document.querySelector('variant-radios');
    if(variantSelector){
      $('#to-cart-baloon_label').html("カラー・サイズを選ぶ");
      $('#to-cart-baloon_button').on('click',function(){
        const elementPosition = variantSelector.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - 80;
        $("html,body").stop(!0, !1).animate({
          scrollTop: offsetPosition
        }, 100, "easeOutQuart");
      });
    }else{
      $('#to-cart-baloon_label').html("ご購入はこちら");
      $('#to-cart-baloon_button').on('click',function(){
        const productInfoContainer = document.querySelector('.product__info-wrapper');
        const offsetPosition = productInfoContainer ? productInfoContainer.getBoundingClientRect().top + window.scrollY - 80 : 0;
        $("html,body").stop(!0, !1).animate({
          scrollTop: offsetPosition
        }, 100, "easeOutQuart");
      });
    }
  }

  //
  if($('#item-detail-info').length && window.innerWidth <= 1000){
    $('.js-item-detail-accordion').on('click',function(){
      $(this).addClass('__on');
    });
  }
  if($('.item-features_items').length && window.innerWidth <= 1000){
    $('.item-features_items').on('click',function(){
      $(this).addClass('__on');
    });
  }
  //
  if($('.js-fade').length){
    inView.offset(200);
    inView('.js-fade').on('enter', el => {
      el.classList.add('__on');
    });
  }
  //
  if($("#coupon-baloon").length){
    $('#coupon-baloon-switch').fadeIn(100);
    if($("#coupon-button-switch").length){
      $('#coupon-button-switch').show();
    }
    $('#coupon-baloon-switch, #coupon-button-switch').on('click',function(){
      $('.coupon-baloon-content_detail').removeClass('__copied __disabled');
      $('body').css('overflow','hidden');
      $('#coupon-baloon').fadeIn(100).addClass('__on');;
    });
    $('.js-coupon-baloon-close').on('click',function(){
      $('body').css('overflow','visible');
      $('#coupon-baloon').fadeOut(100,()=>{
        //$('.coupon-baloon-content_detail').removeClass('__copied __disabled');
      }).removeClass('__on');
    });
  }
  if($(".js-coupon-copy").length){
    $('.js-coupon-copy').on('click',function(){
      const current_coupon = $(this).closest('.coupon-baloon-content_detail');
      if (navigator.clipboard && navigator.clipboard.writeText) {
        const code = $(this).find(".coupon-baloon-content_code-value").val();
        navigator.clipboard.writeText(code).then(function () {
          current_coupon.addClass('__copied');
          $('.coupon-baloon-content_detail').not('.__copied').addClass('__disabled');
        });
      } else {
        $(this).find(".coupon-baloon-content_code-value").select();
        document.execCommand('copy');
        current_coupon.addClass('__copied');
        $('.coupon-baloon-content_detail').not('.__copied').addClass('__disabled');
      }
    });
  } 
  //
  const top_movie = document.getElementById('top-movie');
  if(top_movie){
    if(window.innerWidth <= 1000){
      top_movie.setAttribute('src','https://cdn.shopify.com/videos/c/o/v/4ad49239f99b46ae8112725d9eef7323.mp4');
    }else{
      top_movie.setAttribute('src','https://cdn.shopify.com/videos/c/o/v/5754bb14287a4985a1394ea75c532174.mp4');
    }
    inView.offset(200);
    inView('#top-movie-container').on('enter',function(){
      top_movie.classList.add('__on');
      top_movie.play();
    });
  }
  //
  if(document.getElementById("the-collection_mv")){
    //pc
    let slides_left = [
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv02.webp'},
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv04.jpg'},
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv07.jpg'}
    ];
    let slides_right = [
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv01.webp'},
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv05.jpg'},
    {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv09.jpg'}
    ];
    //sp
    if (window.matchMedia("(max-width: 1000px)").matches) {
      let slides_left = [
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv02.webp'},
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv04.jpg'},
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv07.jpg'}
      ];
      let slides_right = [
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv01.webp'},
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv05.jpg'},
      {src:'https://cdn.shopify.com/s/files/1/0828/3714/3859/files/the-mv09.jpg'}
      ];
    }

    $('#the-collection_mv-l').vegas({
      slides: slides_left,
      transition: 'fade',
      transitionDuration: 3000,
      delay: 5000,
      cover:true,
      preload:true,
      animation: 'kenburnsUpLeft',
      animationDuration: 3000,
      timer: false
    });
    $('#the-collection_mv-r').vegas({
      slides: slides_right,
      transition: 'fade',
      transitionDuration: 3000,
      delay: 5000,
      cover:true,
      preload:true,
      animation: 'kenburnsDownRight',
      animationDuration: 3000,
      timer: false
    });
  }
  //

})(jQuery);
